export const ALL_LANGUAGES = 'all-languages';
export const OTHER_LANGUAGES = 'other';
export const URL_FOREIGN_LANGUAGE_ROUTE = 'language';
export const URL_LOTE_ROUTE = 'lote';
export const URL_LANGUAGE_LEARNING_ROUTE = 'languagelearning';
export const URL_BUNDLES_ROUTE = 'bundles';

/**
 * Normalizes the 'All languages' URL key. It used to be the string `'All languages'` and was converted to the more
 * URL friendly string `'all-languages'`. However the old representation is stored within the backend, so it needs to
 * be normalized before it can be used within the frontend.
 */
export function normalizeAllLanguagesUrlKey(value: string | null | undefined): string | undefined {
    if (typeof value !== 'string') {
        return undefined;
    }

    const normalized = value.toLowerCase().replace(/\W/g, '');

    if (normalized === 'alllanguages') {
        return ALL_LANGUAGES;
    }

    return value;
}
